<div class="login-background">
  <div class="passport-shell">
    <header class="passport-header">
      <div class="logo">
        <img
          src="https://cdn.qne.cloud/qca/assets/img/n3/logo.webp"
          alt="N3 AI Platform"
        />
        <div class="logo-copy">
          <p class="logo-name">AI Platform</p>
          <p class="logo-tagline">Smarter Business. Powered by AI.</p>
        </div>
      </div>

      <div class="header-actions">
        <div class="social-icons">
          <a
            href="{{ fblink }}"
            target="_blank"
            rel="noopener"
            aria-label="QNE on Facebook"
          >
            <img
              alt=""
              role="presentation"
              class="qne-icon switch-icon-white"
              src="../../../assets/img/social/facebook.svg"
            />
          </a>

          <a
            href="{{ iglink }}"
            target="_blank"
            rel="noopener"
            aria-label="QNE on Instagram"
          >
            <img
              alt=""
              role="presentation"
              class="qne-icon switch-icon-white"
              src="../../../assets/img/social/instagram.svg"
            />
          </a>

          <a
            [href]="websiteLink()"
            target="_blank"
            rel="noopener"
            aria-label="QNE website"
          >
            <img
              alt=""
              role="presentation"
              class="qne-icon switch-icon-white"
              src="../../../assets/img/social/web.svg"
            />
          </a>
        </div>

        <button
          type="button"
          class="about-button"
          (click)="onAboutClicked()"
          aria-label="About N3 AI Platform"
        >
          <span class="about-button__full">About N3 AI Platform</span>
          <span class="about-button__short">About</span>
        </button>
      </div>
    </header>

    <div class="passport-stage">
      <section class="passport-intro" aria-labelledby="passport-headline">
        <h1 id="passport-headline" class="main-text">
          <span>AI</span> for Every Part<br />
          of Your Business
        </h1>
        <p class="main-subtext">
          N3 AI help you work smarter, automate tasks, and run your business
          with confidence — connecting your business data for more intelligent
          automation.
        </p>
        <div class="passport-hero">
          <img
            class="passport-hero__img"
            [src]="n3PlatformHeroUrl"
            alt="N3 AI Platform connecting accounting, service, and sales tools"
          />
        </div>
      </section>

      <aside class="passport-auth" aria-label="Account">
        <div class="center-form">
          <div class="custom-tabs">
            <div class="tabs-header">
              <a
                class="tab-item"
                routerLink="login"
                routerLinkActive="active"
                [queryParamsHandling]="'merge'"
                [fragment]="fragment"
              >
                Log In
              </a>

              <a
                class="tab-item"
                routerLink="register"
                routerLinkActive="active"
                [queryParamsHandling]="'merge'"
                [fragment]="fragment"
              >
                Sign Up
              </a>

              <div
                class="tab-indicator"
                [style.width.%]="50"
                [style.transform]="activeTabTransform"
              ></div>
            </div>

            <div class="tabs-body">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </aside>
    </div>

    <footer class="passport-footer">
      @if (countryCode === 'PH') {
        <div class="partners">
          <div class="main-partners">
            <p class="partners__label">QNE Software is a Proud Partner of:</p>
            <div class="partners__logos">
              <div class="acpapp-container">
                <a
                  href="https://www.qne.com.ph/qne-co-presenter-acpapp-2024/"
                  target="_blank"
                  rel="noopener"
                >
                  <img
                    alt="ACPAPP"
                    src="https://cdn.qne.cloud/qca/assets/img/ACPAPP.webp"
                  />
                </a>
              </div>
              <div class="acpaci-container">
                <a
                  href="https://qne.cloud/ph/qne-acpaci-partnership/"
                  target="_blank"
                  rel="noopener"
                >
                  <img
                    alt="ACPACI"
                    src="https://cdn.qne.cloud/qca/assets/img/acpaci_logo.webp"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="academe-partners-container">
            <p class="partners__academe-label">
              Empowering the Next Generation in Colleges and Universities
            </p>
            <div class="academe-partners-logos">
              <button
                type="button"
                class="academe-logos-ctn"
                (click)="onAcademyClicked()"
                aria-label="Open QNE academe partnership page"
              >
                <img
                  alt="PUP"
                  src="https://cdn.qne.cloud/qca/assets/img/academe/PUP.png"
                />
                <img
                  alt="CIT"
                  src="https://cdn.qne.cloud/qca/assets/img/academe/CIT.png"
                />
                <img
                  alt="SSU"
                  src="https://cdn.qne.cloud/qca/assets/img/academe/SSU.png"
                />
              </button>
            </div>
          </div>
        </div>
      }
      <div class="terms">
        <div class="footer-btn-container">
          <span class="terms__copy">
            &#169; {{ companyName }} 2022-{{ today | date: 'yyyy' }}
          </span>
          <span class="terms__sep">|</span>
          <button type="button" class="terms__link" (click)="terms.open()">
            Terms of Service
          </button>
          <span class="terms__sep">|</span>
          <a
            class="terms__link"
            rel="noopener"
            target="_blank"
            [href]="privacyLink()"
          >
            Privacy
          </a>
        </div>
      </div>
    </footer>
  </div>

  <div class="chat-container">
    <button
      type="button"
      class="chat"
      nz-button
      (click)="openChat()"
      nz-tooltip
      nzTooltipTitle="How Can I help you?"
      nzTooltipPlacement="left"
      aria-label="How can I help you?"
    >
      <img
        src="https://cdn.qne.cloud/qca/assets/img/n3/Qbot-AI-Assistant.webp"
        alt=""
        role="presentation"
      />
    </button>
  </div>
</div>

<app-user-terms #terms></app-user-terms>
